import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@qga/roo-ui/components';
import { Flag } from 'components/PropertyPage/PropertyAvailability/RoomTypes/primitives';
import { DEPOSIT_PAY_ENABLED } from 'config';

const OfferDepositPayMessage = ({ depositPay }) => {
  const isDepositPayable = DEPOSIT_PAY_ENABLED && !!depositPay?.depositPayable;

  if (!isDepositPayable) return null;

  return (
    <Flag icon="depositPay" iconSize="16px" color="charcoal">
      <Text fontWeight="bold">Secure with 20% deposit</Text>
    </Flag>
  );
};

OfferDepositPayMessage.propTypes = {
  depositPay: PropTypes.object,
};

OfferDepositPayMessage.defaultProps = {
  depositPay: {
    depositPayable: false,
  },
};

export default OfferDepositPayMessage;
